import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { ReservationsService } from '@ruby/core/http/reservations/reservations.service';
import * as ReservationsActions from '@ruby/modules/reservations/store/actions/reservations.actions';
import { IError } from '@ruby/shared/models/request/error.interface';
import { IReservationDetails } from '@ruby/shared/models/reservations/reservations.interface';

@Injectable()
export class ReservationsEffects {
  loadReservations$ = createEffect(() => this.actions$.pipe(
    ofType(ReservationsActions.loadReservations),
    exhaustMap(action => this.reservationsSvc.getReservationsByStatus(action.data.customerId, action.data.locations, action.data.status).pipe(
      map((reservationsDetails: Array<IReservationDetails>) => ReservationsActions.loadReservationsSuccess({ data: reservationsDetails })),
      catchError((error: IError) => of(ReservationsActions.loadReservationsFailure({ error })))
    ))
  ));

  constructor(
    private actions$: Actions,
    private reservationsSvc: ReservationsService
  ) { }
}
